import { ACTIVITY_LOG_FIELDS } from '@/graphql/fragments/order_activity_logs';
import { gql } from '@apollo/client';

export const QUERY_ACTIVITY_LOG = gql`
    ${ACTIVITY_LOG_FIELDS}
    query ActivityLog($condition: order_activity_logs_bool_exp!) {
        order_activity_logs(where: $condition, order_by: { timestamp: asc }) {
            ...ActivityLogFields
        }
    }
`;

export const UPDATE_ACTIVITY_LOG_REASON = gql`
    ${ACTIVITY_LOG_FIELDS}
    mutation UpdateActivityLogReason(
        $log_id: uuid!
        $reschedule_reason_code: reschedule_reason_code
        $log_detail: String
    ) {
        update_order_activity_logs_by_pk(
            pk_columns: { log_id: $log_id }
            _set: { reschedule_reason_code: $reschedule_reason_code, log_detail: $log_detail }
        ) {
            ...ActivityLogFields
        }
    }
`;
